<template>
  <div class="bm" id="allmap"></div>
</template>
<script>
import Vue from 'vue';
import router from '../../../router';
import { BMPGL } from "@/util/bmpgl.js";
import { mapGetters } from "vuex";
import companyInfoWindow from '../../productionService/components/companyInfoWindow.vue';
import orderInfoWindow from '../../productionService/components/orderInfoWindow.vue';
import agriculturalInfoWindow from '../../productionService/components/agriculturalInfoWindow.vue';
import machineryServiceInfoWindow from '../../productionService/components/machineryServiceInfoWindow.vue';
import { offsetLocation } from '../../../js/utils/util';
import { getCompanyList, getOrderList } from "@/api/projectManage.js";
import {selectCompanyStatistics} from "@/api/screenStatistics.js"
import {getSupplyInfoOfMaterials, getSupplyInfoOfService} from "@/api/supplyDemand.js";
export default {
  props: ["projectList"],
  data() {
    return {
      ak: window.global.bmKey,
      lon: window.global.view.center[0],
      lat: window.global.view.center[1],
      zoom: 12,
      icon: require("../../../assets/地块1.png"),//标记点使用的图标
      icon2: require('../../../assets/农服商.png'),
      icon3: require('../../../assets/农资商.png'),
      progressList: [],
      YTZYList: [],
      doneList: [],
      map: null,
      BMapGL: null,
      currentInfoWindow: null,
      markers: [],
      baseUrl: window.globalUrl.HOME_API,
      pageSize: 500,
    };
  },
  computed: {
    ...mapGetters(["topSelectAreacode", 'topSelectAreaname','identityObj', 'topSelectAreaCenterPoint']),
  },
  watch: {
    topSelectAreaname: function () {
      this.setMapCenter(this.topSelectAreaCenterPoint)
      this.clearMarkers();
      this.getOrderList();
      this.getCompanyList();
      this.getMachineryServiceList();
    }
  },
  mounted() {
    this.initMap();
    this.getOrderList();
    this.getCompanyList();
    this.getMachineryServiceList();
    this.setMapCenter(this.topSelectAreaCenterPoint)
    this.$bus.$on('land-map-company-change', ({ companyId }) => {
      this.setCenterByCompanyCoords(companyId);
    });
    this.$bus.$on('land-map-order-change', ({ orderId }) => {
      this.setCenterByOrderCoords(orderId);
    })
  },
  beforeUnmount() {
      // 移除事件监听
      this.$bus.$off('land-map-order-change');
      this.$bus.$off('land-map-company-change');
    },
  methods: {
    // 新增农事服务商坐标定位方法
    setCenterByCompanyCoords(companyId) {
        if (!this.BMapGL || !this.map) return;

        const marker = this.markers.find(item => {
          if (item.companyData) {
            let companyData = item.companyData;
            if (companyData.id === companyId) {
              return  item;
            }
          }
        })
        if (!marker) return;
        const point = marker.getPosition();
        this.map.centerAndZoom(point, 20);
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }
        this.showCompanyInfo(marker)
    },
    // 新增托管地块坐标定位方法
    setCenterByOrderCoords(orderId) {
      if (!this.BMapGL || !this.map) return;

      // 查找对应的标记点
      const marker = this.markers.find(item => {
        if (item.orderData) {
          let orderData = item.orderData;
          if (orderData.orderId === orderId) {
            return  item;
          }
        }
      })
      if (!marker) return;
      const point = marker.getPosition();
      this.map.centerAndZoom(point, 20);
      if (this.currentInfoWindow) {
        this.currentInfoWindow.close();
      }
      this.showOrderInfo(marker)
    },

    // 根据地区名称设置地图中心点
    async setMapCenter(centerPoint) {

      if (!centerPoint) return;

        const [lon, lat] = centerPoint.split(',');
        if (this.map) {
          const point = new this.BMapGL.Point(lon, lat);
          this.map.centerAndZoom(point, this.zoom);
          this.lon = lon;
          this.lat = lat;
        }

      // if (!this.BMapGL) return;

      // const geocoder = new this.BMapGL.Geocoder();
      // geocoder.getPoint(areaName, point => {
      //   if (point) {
      //     this.map.centerAndZoom(point, this.zoom);
      //     // 如果需要保存最新中心点
      //     this.lon = point.lng;
      //     this.lat = point.lat;
      //     // console.log(this.lon, this.lat, '打印位置信息')
      //   }
      // }, "全国"); // 可以指定省市区提升准确性
    },
    initMap() {
      // 传入密钥获取地图回调。
      BMPGL(this.ak)
        .then((BMapGL) => {
          // 创建地图实例
          let map = new BMapGL.Map("allmap");
          // 创建点坐标 axios => res 获取的初始化定位坐标
          let point = new BMapGL.Point(this.lon, this.lat);

          map.setMapType(BMAP_SATELLITE_MAP);

          var styleJson = [{
              "featureType": "transit", // 例如，隐藏公交站
              "elementType": "labels",
              "stylers": {
                  "visibility": "off"
              }
            },
            // 隐藏商业区域标签
            {
              "featureType": "poi",
              "elementType": "labels",
              "stylers": {"visibility": "off"}
            },
            // 隐藏水系标签
            {
              "featureType": "water",
              "elementType": "labels",
              "stylers": {"visibility": "off"}
            },
            // 隐藏道路标签（路标）
            {
              "featureType": "road.label",
              "elementType": "labels",
              "stylers": {
                "visibility": "off"
              }
            },
            // 隐藏植被区域（树林）
            {
              "featureType": "vegetation",
              "elementType": "all",
              "stylers": {
                "visibility": "off"
              }
            }
          ];
          map.setMapStyleV2({styleJson: styleJson}); // 应用自定义样式

          // 初始化地图，设置中心点坐标和地图级别
          map.centerAndZoom(point, this.zoom);
          //开启鼠标滚轮缩放
          map.enableScrollWheelZoom(true);
          // 添加缩放控件
          var zoomCtrl = new BMapGL.ZoomControl();
          map.addControl(zoomCtrl);
          map.setMaxZoom(17);

          // 保存数据
          this.BMapGL = BMapGL;
          this.map = map;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**
       * 获取托管服务商数据
       */
       async getCompanyList() {
        try {
          const firstPage = await selectCompanyStatistics({
            pageNo: 1,
            pageSize: this.pageSize,
            areaCode: this.topSelectAreacode,
            serviceType: this.$route.query.code == "one" ? 1 : 2,
          });

          if (firstPage.data?.records?.length) {
            this.addCompanyMarkers(firstPage.data.records);
          }

          const sumCount = firstPage.data.total;
          const totalPage = Math.ceil(sumCount / this.pageSize);
          // 使用setTimeout异步加载剩余页数据
          for (let i = 2; i <= totalPage; i++) {
            setTimeout(async () => {
              const pageData = await selectCompanyStatistics({
                pageNo: i,
                pageSize: this.pageSize,
                areaCode: this.areaCode,
                serviceType: this.$route.query.code == "one" ? 1 : 2,
              });
              if (pageData.data?.records?.length) {
                this.addCompanyMarkers(pageData.data.records);
              }
            }, (i-1) * 500); // 每页间隔500ms加载
          }
        } catch (error) {
          console.error('数据获取失败:', error);
        }
      },

      addCompanyMarkers(dataList) {
        if (!dataList || !this.BMapGL) return;
        const BMapGL = this.BMapGL;
        const markerIcon = new BMapGL.Icon(
          this.icon2,
          new BMapGL.Size(25, 30)
        );
        markerIcon.setImageSize(new BMapGL.Size(25, 30));
        const coordMap = new Map();
        dataList.forEach((ele) => {
          if (ele.centerPoint == null) return;

          const point = ele.centerPoint.split(",");

          //处理偏移量
          const key = `${point[0]},${point[1]}`;
          const count = coordMap.get(key) || 0;
          coordMap.set(key, count + 1);

          // 计算偏移后的点坐标
          let location = offsetLocation(count, point[0], point[1]);

          let pt = new BMapGL.Point(location.lng, location.lat);
          let marker = new BMapGL.Marker(pt, { icon: markerIcon });
          ele.companyName =   ele.companyName != null ? ele.companyName : "";
          ele.companyAddress =   ele.companyAddress != null ? ele.companyAddress : "";
          marker.companyData = ele;
          marker.addEventListener('click', e => {
              this.showCompanyInfo(e.target);
          });

          this.markers.push(marker);
          this.map.addOverlay(marker);

        });
      },

      showCompanyInfo(marker) {
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
        }
        const info = marker.companyData;
        console.log(info, '查看农服商info')
        // console.log(info.companyVo, "列表信息")

        let width = 400;
        let height = 270;
        //处理时间
        if (info.companyVo && info.companyVo.length > 0) {
          info.companyVo.forEach((item) => {
            item.dayNum = item.createTime ? item.createTime.substr(8, 2) : "";
            item.yearNum = item.createTime
              ? item.createTime.substr(0, 4)
              : "";
            item.monthNum = item.createTime
              ? item.createTime.substr(5, 2)
              : "";
          })
        } else {
          height = 150;
        }
        info.authId = info.id;

        const ComponentClass = Vue.extend(companyInfoWindow);
        const instance = new ComponentClass({
          router,
          propsData: {
            info,
          },
        });
        const content = instance.$mount().$el;

        this.currentInfoWindow = new BMapGL.InfoWindow(content, {
          width: width,
          height: height,
          offset: new BMapGL.Size(0, -10)
        });
        this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
      },

       /**
     * 农机服务商列表
     */
    async getMachineryServiceList() {
      try {
          const firstPage = await getSupplyInfoOfService({
            pnum: 1,
            psize: this.pageSize,
            areaCode: this.topSelectAreacode,
            serviceType: this.$route.query.code == "one" ? 1 : 2,
          });
          if (firstPage.data?.length) {
            this.addMachineryServiceMarkers(firstPage.data);
          }

          const sumCount = firstPage.dataNum;
          const totalPage = Math.ceil(sumCount / this.pageSize);
          // 使用setTimeout异步加载剩余页数据
          for (let i = 2; i <= totalPage; i++) {
            setTimeout(async () => {
              const pageData = await getSupplyInfoOfService({
                pnum: i,
                psize: this.pageSize,
                areaCode: this.topSelectAreacode,
                serviceType: this.$route.query.code == "one" ? 1 : 2,
              })
              if (pageData.data?.length) {
                this.addMachineryServiceMarkers(pageData.data);
              }
            }, (i-1) * 500)
          }
      } catch (error) {
        console.error('农机服务商数据获取失败:', error);
      }
    },

    addMachineryServiceMarkers(dataList) {
      if (!dataList || !this.BMapGL) return;
        const BMapGL = this.BMapGL;
        const markerIcon = new BMapGL.Icon(
          this.icon2,
          new BMapGL.Size(25, 30)
        );
        markerIcon.setImageSize(new BMapGL.Size(25, 30));
        const coordMap = new Map();
        dataList.forEach((ele) => {
          if (ele.centerPoint == null) return;

          const point = ele.centerPoint.split(",");

          //处理偏移量
          const key = `${point[0]},${point[1]}`;
          const count = coordMap.get(key) || 0;
          coordMap.set(key, count + 1);

          // 计算偏移后的点坐标
          let location = offsetLocation(count, point[0], point[1]);

          let pt = new BMapGL.Point(location.lng, location.lat);
          let marker = new BMapGL.Marker(pt, { icon: markerIcon });
          marker.machineryServiceData = ele;
          marker.addEventListener('click', e => {
              this.showMachineryServiceInfo(e.target);
          });

          this.markers.push(marker);
          this.map.addOverlay(marker);
        });
    },

    showMachineryServiceInfo(marker) {
      if (this.currentInfoWindow) {
        this.map.closeInfoWindow(this.currentInfoWindow);
      }
      const info = marker.machineryServiceData;
      console.log(info, '查看农机服务商info')

      let width = 270;
      let height = 150;
      info.authId = info.companyAuthId;

      const ComponentClass = Vue.extend(machineryServiceInfoWindow);
      const instance = new ComponentClass({
        router,
        propsData: {
          info,
        },
      });
      const content = instance.$mount().$el;

      this.currentInfoWindow = new BMapGL.InfoWindow(content, {
        width: 270,
        height: 170,
        offset: new BMapGL.Size(0, -10)
      });
      this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
    },

      /**
       * 获取托管地块数据

       */
      async getOrderList() {
        try {
          const firstPage = await getOrderList({
            pnum: 1,
            psize: this.pageSize,
            areaCode: this.topSelectAreacode,
            orderType: this.$route.query.code == "one" ? 1 : 2,
          });

          if (firstPage.data?.length) {
            this.addOrderMarkers(firstPage.data);
          }

          const sumCount = firstPage.dataNum;
          const totalPage = Math.ceil(sumCount / this.pageSize);

          // 使用setTimeout异步加载剩余页数据
          for (let i = 2; i <= totalPage; i++) {
            setTimeout(async () => {
              const pageData = await getOrderList({
                pageNo: i,
                pageSize: this.pageSize,
                areaCode: this.areaCode,
                orderType: this.$route.query.code == "one" ? 1 : 2,
              });
              if (pageData.data?.length) {
                this.addOrderMarkers(pageData.data);
              }
            }, (i-1) * 500); // 每页间隔500ms加载
          }
        } catch (error) {
          console.error('数据获取失败:', error);
        }
      },

      /**
       *
       * @param dataList 绘制托管地块标点
       */
      addOrderMarkers(dataList) {

        if (!dataList || !this.BMapGL) return;
        const BMapGL = this.BMapGL;
        const markerIcon = new BMapGL.Icon(
          this.icon,
          new BMapGL.Size(25, 30)
        );
        markerIcon.setImageSize(new BMapGL.Size(25, 30));
        const coordMap = new Map();
        dataList.forEach((ele) => {
          if (ele.centerPoint == null) return;

          const point = ele.centerPoint.split(",");

          //处理偏移量
          const key = `${point[0]},${point[1]}`;
          const count = coordMap.get(key) || 0;
          coordMap.set(key, count + 1);

          // 计算偏移后的点坐标
          let location = offsetLocation(count, point[0], point[1]);

          let pt = new BMapGL.Point(location.lng, location.lat);
          let marker = new BMapGL.Marker(pt, { icon: markerIcon });

          ele.orderType = ele.orderType == 1 ? "全程托管" : "环节托管";
          ele.seasonYield = ele.seasonYield == null ? "" : ele.seasonYield + "KG/亩";
          ele.estimatePrice = ele.estimatePrice == null ? "" : ele.estimatePrice + "元";
          ele.remark = ele.remark == null ? "" : ele.remark;

          marker.orderData = ele;
          marker.addEventListener('click', e => {
              this.showOrderInfo(e.target);
          });
          this.markers.push(marker);
          this.map.addOverlay(marker);

        });
      },

      showOrderInfo(marker) {
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
        }
        const info = marker.orderData;
        //现场照片
        const livePhoto = info.livePhotos;
        const livePhotoList = [];
        if (livePhoto) {
          const livePhotoArr = JSON.parse(livePhoto);
          livePhotoArr.forEach((item) => {
            livePhotoList.push(this.baseUrl + "admin/file/get?ossFilePath=" + item.url);
          });
        }
        info.livePhotoList = livePhotoList;

        const ComponentClass = Vue.extend(orderInfoWindow);
        const instance = new ComponentClass({
          router,
          propsData: {
            info,
          },
        });
        const content = instance.$mount().$el;

        this.currentInfoWindow = new BMapGL.InfoWindow(content, {
          width: 300,
          height: 400,
          offset: new BMapGL.Size(0, -10)
        });
        this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
      },


      /**
       * 获取农资商数据

       */
      async getAgriculturalList() {
        try {
          const firstPage = await getSupplyInfoOfMaterials({
            pnum: 1,
            psize: this.pageSize,
            areaCode: this.topSelectAreacode
          });
          if (firstPage.data?.length) {
            this.addAgriculturalMarkers(firstPage.data);
          }
          const sumCount = firstPage.dataNum;
          const totalPage = Math.ceil(sumCount / this.pageSize);
          // 使用setTimeout异步加载剩余页数据
          for (let i = 2; i <= totalPage; i++) {
            setTimeout(async () => {
              const pageData = await getSupplyInfoOfMaterials({
                pageNo: i,
                pageSize: this.pageSize,
                areaCode: this.areaCode
              });
              if (pageData.data?.length) {
                this.addAgriculturalMarkers(pageData.data);
              }
            }, (i-1) * 500); // 每页间隔500ms加载
          }

        } catch (error) {
          console.error('数据获取失败:', error);
        }
      },

       /**
       *
       * @param dataList 绘制农资商标点
       */
       addAgriculturalMarkers(dataList) {
        if (!dataList || !this.BMapGL) return;
        const BMapGL = this.BMapGL;
        const markerIcon = new BMapGL.Icon(
          this.icon3,
          new BMapGL.Size(25, 40)
        );
        markerIcon.setImageSize(new BMapGL.Size(25, 30));
        // console.log(dataList, '查看农资商dataList')
        const coordMap = new Map();
        dataList.forEach((ele) => {

           //处理偏移量
           const key = `${ele.longitude},${ele.latitude}`;
          const count = coordMap.get(key) || 0;
          coordMap.set(key, count + 1);

          // 计算偏移后的点坐标
          let location = offsetLocation(count, ele.longitude, ele.latitude);

          let pt = new BMapGL.Point(location.lng, location.lat);
          let marker = new BMapGL.Marker(pt, { icon: markerIcon });
          marker.AgriculturaData = ele;
          marker.addEventListener('click', e => {
              this.showAgriculturaInfo(e.target);
          });
          this.markers.push(marker);
          this.map.addOverlay(marker);

        });
      },

      showAgriculturaInfo(marker) {
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
        }
        const info = marker.AgriculturaData;
        console.log(info, '查看农资info')

        const ComponentClass = Vue.extend(agriculturalInfoWindow);
        const instance = new ComponentClass({
          router,
          propsData: {
            info,
          },
        });
        const content = instance.$mount().$el;

        this.currentInfoWindow = new BMapGL.InfoWindow(content, {
          width: 300,
          height: 210,
          offset: new BMapGL.Size(0, -10)
        });
        this.map.openInfoWindow(this.currentInfoWindow, marker.getPosition());
      },

      clearMarkers() {
        this.markers.forEach((marker) => {
          this.map.removeOverlay(marker);
        });
        if (this.currentInfoWindow) {
          this.map.closeInfoWindow(this.currentInfoWindow);
        }
      },

    // back() {
    //   this.initMap();
    // },
  },
};
</script>
<style lang="less" scoped>
.bm {
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.boxTitle {
  font-size: 16px;
  color: #00aeee;
  font-weight: 600;
}
/deep/ .anchorBL {
  display: none;
}

/deep/ .BMap_bubble_buttons {
  display: none;
}
</style>
